<template>
	<div class="blockItem">
		<div class="blockBody">
			<div class="blockTitle">
				<div class="blockTitleL">德育评价维度分析</div>
				<!-- <div class="blockTitleR">66666</div> -->
			</div>
			<div class="blockContent">
				<!-- <dv-charts class="charts" :option="option" /> -->
				<div class="charts" id="randar"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts';
	
	export default {
		data() {
			return {
				option: {
					radar: {
						polygon: true,
						axisLabel: {
							style: {
								fill: '#FFFFFF',
								fontSize: 18
							}
						},
						indicator: [{
								name: '学习习惯',
								max: 300
							},
							{
								name: '文明礼仪',
								max: 300
							},
							{
								name: '仪容仪表',
								max: 300
							},
							{
								name: '集会健体',
								max: 300
							},
							{
								name: '值日劳动',
								max: 300
							},
							{
								name: '健康生活',
								max: 300
							},
							{
								name: '才艺特长',
								max: 300
							}
						]
					},
					series: [
						{
							name: '班级平均分',
							type: 'radar',
							data: [116, 256, 280, 244, 240, 255,220],
							label: {
								show: false
							},
							animationCurve: 'easeOutBounce'
						}
					]
				}
			}
		},
		mounted() {
			this.setChart();
		},
		methods: {
			setChart() {
				let rich = {
				    total: {
				        color: "#ffc72b",
				        fontSize: 18,
				        align: 'center',
				        padding: [1, 0],
				    },
				    total_text: {
				        fontSize: 15,
				        align: 'center'
				    },
				};
				let myChart = echarts.init(document.getElementById('randar'))
				let option = {
					grid: {
						top: "1%",
						left: "1%",
						right: "1%",
						bottom: "1%"
					},
					tooltip: {
						trigger: 'axis'
					},
					radar: [{
						nameGap: 5,
						indicator: [{
								name: '学习习惯',
								max: 300
							},
							{
								name: '文明礼仪',
								max: 300
							},
							{
								name: '仪容仪表',
								max: 300
							},
							{
								name: '集会健体',
								max: 300
							},
							{
								name: '值日劳动',
								max: 300
							},
							{
								name: '健康生活',
								max: 300
							},
							{
								name: '才艺特长',
								max: 300
							}
						],
						center: ['50%', '50%'],
						radius: '75%',
						name: {
							textStyle: {
								fontSize: 15,
								color: '#ffffff'
							}
						},
						splitLine: {
							lineStyle: {
								color: '#696969',
								width: 1
							},
						},
						splitArea: {
							show: true,
							areaStyle: {
								color: '#001A29',
							}
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#696969'
							}
						}
					}],
					legend: {
						selectedMode: false,
						top: '0', // 图例组件离容器顶部的距离
						right: '0%',
						icon: 'none',
						textStyle: {
							fontSize: 15,
							rich: rich
						}
					},
					series: [{
						type: 'radar',
						animation: false, // 是否开启动画。
						tooltip: {
							trigger: 'item'
						},
						data: [{
							value: [285, 165, 205, 260, 182, 243, 243]
						}],
						symbolSize: 10,
						itemStyle: {
							normal: {
								color: 'rgba(13, 178, 255, 1)',
								borderColor: 'rgba(13, 178, 255, 0.2)',
								borderWidth: 12,
							}
						},
						lineStyle: {
							normal: {
								color: "rgba(13, 178, 255, 1)",
								width: 2
							}
						},
						areaStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(13, 178, 255, 1)'
								}, {
									offset: 0.5,
									color: 'rgba(13, 178, 255,0)'
								}, {
									offset: 1,
									color: 'rgba(13, 178, 255, 0.9)'
								}], false)
							}
						}
					}, ],
				}
				myChart.setOption(option);
			}
		}
	}
</script>

<style lang="less" scoped>
	.charts {
		width: 100%;
		height: 100%;
	}
</style>
